// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getRoom, insertRoom, roomSelector, updateRoom} from "./roomSlice";

import {Colors} from "../../../assets/Colors";

const RoomPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const room = useSelector(roomSelector);

    useEffect(() => {
        dispatch(
            getRoom({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && room.isGetSuccess && !room.isGetFetching) {
            let calc = room?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = room.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && room.isGetSuccess && !room.isGetFetching) {
            let calc = room?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = room.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !room?.isGetFetching &&
            room.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = room?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = room.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getRoom({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (room.isGetSuccess) {
                alertService.success(room.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getRoom({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (room.isUpdateSuccess) {
                alertService.success(room.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateRoom({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetRoom(params) {
    //   return dispatch(getRoom(params));
    // }

    function handleInsertRoom(param) {
        setInsertFetch(true);
        const params = {
            RoomName: param.inputOneValue,
            Jenis: param.dropDownJenisValue,
        };

        dispatch(insertRoom(params));
    }

    function handleUpdateRoom(param) {
        setUpdateFetch(true);

        const params = {
            RoomName: param.inputOneValue,
            Jenis: param.dropDownJenisValue,
            RoomID: currentData.RoomID,
            status: param.status,
        };
        dispatch(updateRoom(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getRoom(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getRoom(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = room.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? room.count : newCount,
            search: search,
        };
        dispatch(getRoom(params));

        setPage(1);
        setCount(newCount === "-1" ? room.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>
                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Room"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Room"
                                tableData={room.data}
                                colOneTitle="ID"
                                colOneData="RoomID"
                                colTwoTitle="Nama Room"
                                colTwoData="RoomName"
                                colThreeTitle="Jenis"
                                colThreeData="Jenis"
                                status="Status"
                                fetching={room.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Room"
                        dropDownJenis={true}
                        dropDownJenisValue=""
                        inputOneTitle="Nama Room"
                        inputOneValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertRoom}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.RoomID}
                        modal={handleModal}
                        modalTitle="Ubah Room"
                        dropDownJenis={true}
                        dropDownJenisValue={currentData.Jenis}
                        inputOneTitle="Nama Room"
                        inputOneValue={currentData.RoomName}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateRoom}
                    />
                )}
            </div>
        );
    }
};

export default RoomPage;
